import React, { useEffect } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useTheme } from '../context/ThemeContext';
import { useAuth } from '../context/AuthContext';
import styles from '../styles/NavButton.module.css';
import { getBrutalistStyles } from '../styles/brutalist';
import BrutalistNavigation from '../components/BrutalistNavigation';

const AccesoAutoescuela = () => {
  const { isDarkMode } = useTheme();
  const { isAuthenticated, school } = useAuth();
  const navigate = useNavigate();
  const brutalistStyles = getBrutalistStyles(isDarkMode);
  
  // Redirect to dashboard if already authenticated as a school
  useEffect(() => {
    console.log('[AUTH-DEBUG] AccesoAutoescuela - Auth State:', { isAuthenticated, hasSchool: !!school });
    if (isAuthenticated && school) {
      console.log('[AUTH-DEBUG] AccesoAutoescuela - Redirecting to dashboard');
      navigate('/dashboard');
    }
  }, [isAuthenticated, school, navigate]);

  return (
    <>
      <BrutalistNavigation />
      <div className="container" style={{
        marginTop: '2rem',
        '@media screen and (maxWidth: 768px)': {
          marginTop: '3rem'
        }
      }}>
        <h1 style={{
          ...brutalistStyles.brutalistTitle,
          textAlign: 'center',
          marginBottom: '2rem',
          borderBottom: `4px solid ${isDarkMode ? '#fff' : '#000'}`,
          paddingBottom: '0.5rem'
        }}>
          ÁREA DE AUTOESCUELAS
        </h1>

        <p style={{
          textAlign: 'center',
          fontSize: '1.1rem',
          marginBottom: '3rem',
          fontWeight: 500,
          maxWidth: '600px',
          margin: '0 auto 3rem',
          color: isDarkMode ? '#fff' : '#000'
        }}>
          Accede a tu cuenta o registra tu autoescuela para comenzar a gestionar tus servicios.
        </p>

        <nav style={{
          marginBottom: 'clamp(3rem, 8vw, 5rem)'
        }}>
          <ul style={{
            listStyle: 'none',
            padding: '0',
            display: 'grid',
            gap: '1rem',
            maxWidth: '600px',
            margin: '0 auto'
          }}>
            <li>
              <Link
                to="/iniciar-sesion"
                className={`${styles.navButton} ${isDarkMode ? styles.dark : ''}`}
              >
                <h3 className={styles.title}>Iniciar Sesión</h3>
                <p className={styles.description}>
                  Accede a tu cuenta de autoescuela
                </p>
              </Link>
            </li>
            <li>
              <Link
                to="/registrar-nueva-autoescuela"
                className={`${styles.navButton} ${styles.testCompleto} ${isDarkMode ? styles.dark : ''}`}
              >
                <h3 className={styles.title}>Registrar Nueva Autoescuela</h3>
                <p className={styles.description}>
                  Crea una cuenta para tu autoescuela
                </p>
              </Link>
            </li>
          </ul>
        </nav>
      </div>
    </>
  );
};

export default AccesoAutoescuela;